// l'idee est de créer des points de sauvegarde a la main, et de reprendre à cet endroit

import SequencesManager from "react-sdk/haxelibs/SequencesManager"
import AppState from "./AppState"

import Minigames from "./Minigames/Minigames"
import MinigameFtues from "./Minigames/MinigameFtues"
import { FTUE_state, loadFTUEState } from "./FTUE"
import ObjectiveFile from "./Objectives/ObjectiveFile"

class SaveGame {
  saveTimer = null // TODO petit timer pour debounce et éviter de save plusieurs fois presque en meme temps

  // NOTE : stocker ici des états qu'on pourrait utiliser dans le code ou le SM pour reloader au bon endroit
  // que des booleens
  states = {

    sequenceIntroVue: false,
    seq1_bureauTrashVue: false

  }


  getState(id) {
    return this.states[id]
  }
  setState(id, value) {
    this.states[id] = value
  }




  hasSave() {
    return new Promise( (resolve, reject) => {
      resolve()
    })
  }

  getOrCreateSaveId() {
    return this.hasSave()
    .then((id) => {

      if(id) return id
      else {
        return new Promise( (resolve, reject) => {
          resolve()
        })
      }

    })
  }


  save() {
    let mapState = AppState.getMapState ? AppState.getMapState() : AppState.loadedMapState
    let state = {
      sm_state: SequencesManager.stateToJson(),
      objectives: AppState.soloObjectives.stateToJson(),
      // objectives: ObjectiveFile.stateToJson(),

      minigames: Minigames.stateToJson(),
      minigames_ftue: MinigameFtues.stateToJson(),
      map: mapState,
      states: this.states,
      ftue: FTUE_state,
      uiState: AppState.UI_visibilities
    }

    return this.getOrCreateSaveId()
    .then(id => {

    })
  }

  load() {
    return this.hasSave()
    .then(id => {
      if(id) {
        return new Promise( (resolve, reject) => {            resolve()
        })
      }
    })
    .then(() => AppState.userGetStars())
    .then((stars) => AppState.userStars = stars)
    .then(() => AppState.initTeamObjectivesState())
  }

  clearSave() {
    return this.hasSave()
    .then(id => this.deleteSaves([id]))
    .then(() => AppState.userSaveStars(0, false))
  }


  deleteSaves(ids) {
    return new Promise( (resolve, reject) => {
      resolve()


    })
  }

}


export default new SaveGame()